import { OtcTabBody, OtcTabText } from "../../styles/MainOtcStyle";
import Text from "../../utils/Text"

const OtcTabButton = ({text, active, onTabButtonClicked} ) => {

    return (
        <OtcTabBody active={active} onClick={onTabButtonClicked}>
            <OtcTabText active={active}>
                <Text tid={text} />
            </OtcTabText>
        </OtcTabBody>
    )
}


export default OtcTabButton;